<template>
  <div>
    <form action="" class="mt-4">
      <div class="form-row">
        <div class="form-group col-12">
          <label for="user_first_name">{{ $t("email_header") }}</label>
          <app-input type="text" v-model="email_header"/>
          <img :src="email_header" class="mw-100"/>
        </div>
        <div class="form-group col-12">
          <label for="user_first_name">{{ $t("email_footer") }}</label>
          <app-input type="text" :required="true" v-model="email_footer"/>
          <img :src="email_footer" class="mw-100"/>
        </div>
      </div>
      <button type="button" class="btn btn-primary mr-2" @click.prevent="updateBanner">Submit</button>
    </form>
  </div>
</template>
<script>
import { FormMixin } from "../../../../core/mixins/form/FormMixin";
import { axiosGet, axiosPost } from "../../../Helpers/AxiosHelper";
import {UPDATE_EMAIL_BANNER} from "../../../../app/Config/ApiUrl";

export default {
  mixins: [FormMixin],
  data() {
    return {
      //   readOnly: true,
      setModal: false,
      email_header: '',
      email_footer: '',
      info: {},
      
    };
  },
  computed: {
    appSettings(){
      return this.$store.state.settings;
    }
  },
  watch:{

  },
  mounted() {
    this.email_header = this.appSettings.appSettings.email_header_banner;
    this.email_footer = this.appSettings.appSettings.email_footer_banner;
  },
  methods: {
    updateBanner(){
  
        this.info = {
          'email_header_banner': this.email_header,
          'email_footer_banner': this.email_footer,
        }
        axiosPost(UPDATE_EMAIL_BANNER, this.info)
          .then((res) => {

            if (res.data.message) {
              this.$toastr.s(res.data.message);
            }
            else {
            this.$toastr.w(res.data.info);
            }
            this.setModal = false;
          })
          .catch((error) => {
            
            this.$toastr.e(error.data.type);
          })
          .finally(() => {
            location.reload();
            this.preloader = false;
          });
      }
      // this.setModal = false;
    },
  }
</script>